<template>
  <main>
    <Hero
      :title="home.bemvindo"
      :presentation="home.mensageminicial"
      :videoImage="home.imagemvideo"
      :videoUrl="home.urlvideo"
      :buttonShow="home.temlinkvotar"
      :buttonText="home.msgSigaVoto"
      :buttonUrl="buttonUrl"
    ></Hero>

    <section
      class="py-12 bg-gray-50 border-y border-gray-200"
      v-if="
        home.exibeblocosituacao !== false && home.exibeblocosituacao !== 'false'
      "
    >
      <div class="container mx-auto px-4 max-w-4xl text-center">
        <h3 class="text-2xl font-bold text-gray-800 mb-3">
          {{ home.tituloSituacao || "Situação Eleitoral" }}
        </h3>
        <p class="text-gray-600 mb-8 text-lg">
          {{
            home.textoSituacao ||
            "Verifique rapidamente se você está apto a votar nas eleições deste ano. A consulta é rápida e exige apenas o seu número de inscrição."
          }}
        </p>
        <div class="flex justify-center">
          <Button
            color="white"
            background="blue-600"
            size="lg"
            :shadown="true"
            @action="$router.push('/consulta-situacao')"
          >
            <i class="fa fa-search mr-2"></i>
            {{ home.textoBotaoSituacao || "Consultar Situação Eleitoral" }}
          </Button>
        </div>
      </div>
    </section>

    <RegionalInfo
      v-if="
        home.exibeblocoregional !== false && home.exibeblocoregional !== 'false'
      "
    />

    <section v-if="cards.length > 0">
      <div class="section-container">
        <div class="section-title">
          <h4 class="text-lime-600">Precisando de ajuda?</h4>
        </div>
        <Card :cards="cards"></Card>
      </div>
    </section>
  </main>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Hero from "../components/Hero.vue";
import Card from "@/components/elements/Card.vue";
import RegionalInfo from "@/components/RegionalInfo.vue";
import Button from "@/components/elements/Button.vue";

export default Vue.extend({
  name: "Home",
  data() {
    return {
      home: {},
      cards: [],
      buttonUrl: "",
    };
  },
  computed: {
    ...mapGetters("eleicaonet", ["getParamHotsite"]),
  },
  components: {
    Hero,
    Card,
    RegionalInfo,
    Button,
  },
  mounted() {
    this.home = this.getParamHotsite.home;
    this.buttonUrl = this.getParamHotsite.uri_votar;

    let filterCards = [];

    this.getParamHotsite.cards.forEach((card) => {
      if (card.home) {
        filterCards.push(card);
      }
    });

    this.cards = filterCards;
  },
});
</script>
